import React, { useEffect, useState, forwardRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "../../../styles/print.css";

import PrintHeader from "../../../components/PrintHeader";
import PrintFooter from "../../../components/PrintFooter";

const API_URL = process.env.REACT_APP_API_URL;

function All_Report_download() {
    const { male_id } = useParams();


    const [maleForm, setMaleForm] = useState({});
    const [femaleForm, setFemaleForm] = useState({});
    const [maleHormonalRows, setMaleHormonalRows] = useState([]);
    const [femaleHormonalRows, setFemaleHormonalRows] = useState([{}]);
    const [PiwilMrnaModel, setPiwilMrnaModel] = useState([{}]);
    const [ProteinModel, setProteinModel] = useState([{}]);
    const [values, setDFISCDKIT] = useState([{}]);
    const [COMET, setCOMET] = useState([{}]);
    const [Oxidative, setOxidative] = useState([{}]);
    const [ymicron, setYmicron] = useState([{}]);
    const [Telomere, setTelomerelength] = useState([{}]);

    const [followup_14days, setfollowup_14days] = useState([]);
    const [followup_11_13weeks, setfollowup_11_13weeks] = useState([]);
    const [followup_18_20weeks, setfollowup_18_20weeks] = useState([]);
    const [followup_24weeks, setfollowup_24weeks] = useState([]);
    const [followup_fertilization_master, setfollowup_fertilization_master] = useState([]);


    useEffect(() => {
        document.body.classList.add("print-page");

        return () => {
            document.body.classList.remove("print-page");
        };
    }, []);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token || !male_id) return;

        axios.get(`${API_URL}/partner_details_all_data_id_wise/${male_id}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(res => {
                const data = res.data.partner_data;

                if (data?.male) {
                    setMaleForm(prev => ({
                        ...prev,
                        ...data.male,
                        pmid: data.male?.pmid,
                        sample_master_id: data.male?.sample_master_id
                    }));
                }

                if (data?.female) {
                    setFemaleForm(prev => ({
                        ...prev,
                        ...data.female,
                        pfid: data.female?.pfid
                    }));
                }
                if (data?.PiwilMrnaModel) {
                    setPiwilMrnaModel(prev => ({
                        ...prev,
                        ...data.PiwilMrnaModel,

                    }));
                }
                if (data?.PiwilProteinExpressionModel) {
                    setProteinModel(prev => ({
                        ...prev,
                        ...data.PiwilProteinExpressionModel,
                    }));
                }
                if (data?.DFISCDKitModel) {
                    setDFISCDKIT(prev => ({
                        ...prev,
                        ...data.DFISCDKitModel,
                    }));
                }
                if (data?.CometAssayModel) {
                    setCOMET(prev => ({
                        ...prev,
                        ...data.CometAssayModel,
                    }));
                }
                if (data?.OxidativeStressModel) {
                    setOxidative(prev => ({
                        ...prev,
                        ...data.OxidativeStressModel,
                    }));
                }
                if (data?.YMicroDeletionModel) {
                    setYmicron(prev => ({
                        ...prev,
                        ...data.YMicroDeletionModel,
                    }));
                }
                if (data?.YMicroDeletionModel) {
                    setYmicron(prev => ({
                        ...prev,
                        ...data.YMicroDeletionModel,
                    }));
                }
                if (data?.YMicroDeletionModel) {
                    setTelomerelength(prev => ({
                        ...prev,
                        ...data.YMicroDeletionModel,
                    }));
                }

                /////////////////////////following is folloup data/////////



                if (data?.followup_14days) {
                    setfollowup_14days(data.followup_14days);
                }

                if (data?.followup_11_13weeks) {
                    setfollowup_11_13weeks(data.followup_11_13weeks);
                }


                if (data?.followup_18_20weeks) {
                    setfollowup_18_20weeks(data.followup_18_20weeks);
                }




                if (data?.followup_24weeks) {
                    setfollowup_24weeks(data.followup_24weeks);
                }
                if (data?.followup_fertilization_master) {
                    setfollowup_fertilization_master(data.followup_fertilization_master);
                }
                //////////////////////////////////////////////////////////


                setMaleHormonalRows(data.male_hormonal || []);
                setFemaleHormonalRows(data.female_hormonal || []);
            })
            .catch(console.error);

    }, [male_id]);

    return (
        <div className="print-page print-container">
            <PrintHeader />
            <h5 className="text-center" style={{ marginTop: "10px" }}>Patient Complete Report</h5>

            {/* Male Details */}
            <h4>Male Details</h4>
            <table className="print-table">
                <tbody>
                    <tr>
                        <th style={{ width: "20%" }}>Sample Code</th>
                        <td style={{ width: "30%" }}>{maleForm.sample_id}</td>
                        <th style={{ width: "20%" }}>Patient Name</th>
                        <td style={{ width: "30%" }}>{maleForm.Patient_Name}</td>
                    </tr>

                    <tr> <th style={{ width: "20%" }}>CRN No.</th>
                        <td style={{ width: "30%" }}>{maleForm.CRN_No}</td>
                        <th style={{ width: "20%" }}>Age(Yrs)</th>
                        <td style={{ width: "30%" }}>{maleForm.Age}</td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Education</th>
                        <td style={{ width: "30%" }}>{maleForm.Education}</td>
                        <th style={{ width: "20%" }}>Occupation</th>
                        <td style={{ width: "30%" }}>{maleForm.Occupation}</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Smoking</th>
                        <td style={{ width: "30%" }}> {Number(maleForm.Smoking) === 1 ? "No" : Number(maleForm.Smoking) === 2 ? "Former Smoker" : Number(maleForm.Smoking) === 3 ? "Current Smoker (Daily)" : Number(maleForm.Smoking) === 4 ? "Current Smoker (Occasional)" : Number(maleForm.Smoking) === 5 ? "Data Not Available" : "Unknown"} </td>

                        <th style={{ width: "20%" }}>Chewing Tobacco</th>
                        <td style={{ width: "30%" }}> {Number(maleForm.Chewing_Tobacco) === 1 ? "No" : Number(maleForm.Chewing_Tobacco) === 2 ? "Former User" : Number(maleForm.Chewing_Tobacco) === 3 ? "Current User (Active)" : Number(maleForm.Chewing_Tobacco) === 4 ? "Current User (Occasional)" : Number(maleForm.Chewing_Tobacco) === 5 ? "Data Not Available" : "Unknown"} </td>

                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Alcohol</th>
                        <td style={{ width: "30%" }}> {Number(maleForm.Alcohol) === 1 ? "No" : Number(maleForm.Alcohol) === 2 ? "Former Drinker" : Number(maleForm.Alcohol) === 3 ? "Current Drinker (Active)" : Number(maleForm.Alcohol) === 4 ? "Current Drinker (Occasional)" : Number(maleForm.Alcohol) === 5 ? "Data Not Available" : "Unknown"} </td>

                    </tr>
                    <tr>
                        <th
                            colSpan={4}
                            style={{
                                fontWeight: "bold",        // makes it bold
                                fontSize: "14pt",          // adjust font size
                                padding: "8px",
                                color: "black"            // add some padding
                            }}
                        >
                            Medical History
                        </th>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Diabetes</th>
                        <td style={{ width: "30%" }}> {Number(maleForm.Diabetes) === 0 ? "No" : Number(maleForm.Diabetes) === 1 ? "Yes" : Number(maleForm.Diabetes) === 2 ? "Data Not Available" : "Unknown"} </td>

                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Diabetes Type</th>
                        <td style={{ width: "30%" }}>{maleForm.Diabetes_Type}</td>
                        <th style={{ width: "20%" }}>Diabetes Duration</th>
                        <td style={{ width: "30%" }}>{maleForm.Diabetes_Duration}</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Hypertension</th>
                        <td style={{ width: "30%" }}> {Number(maleForm.Hypertension) === 0 ? "No" : Number(maleForm.Hypertension) === 1 ? "Yes" : Number(maleForm.Hypertension) === 2 ? "Data Not Available" : "Unknown"} </td>
                        <th style={{ width: "20%" }}>Hypertension Duration</th>
                        <td style={{ width: "30%" }}>{maleForm.Hypertension_Duration}</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Mumps</th>
                        <td style={{ width: "30%" }}> {Number(maleForm.Mumps) === 0 ? "No" : Number(maleForm.Mumps) === 1 ? "Yes" : Number(maleForm.Mumps) === 2 ? "Data Not Available" : "Unknown"} </td>
                        <th style={{ width: "20%" }}>Trauma</th>
                        <td style={{ width: "30%" }}> {Number(maleForm.Trauma) === 0 ? "No" : Number(maleForm.Trauma) === 1 ? "Yes" : Number(maleForm.Trauma) === 2 ? "Data Not Available" : "Unknown"} </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Surgeries</th>
                        <td style={{ width: "30%" }}> {Number(maleForm.Surgeries) === 0 ? "No" : Number(maleForm.Surgeries) === 1 ? "Yes" : Number(maleForm.Surgeries) === 2 ? "Data Not Available" : "Unknown"} </td>
                        <th style={{ width: "20%" }}>Hernia</th>
                        <td style={{ width: "30%" }}> {Number(maleForm.Hernia) === 0 ? "No" : Number(maleForm.Hernia) === 1 ? "Yes" : Number(maleForm.Hernia) === 2 ? "Data Not Available" : "Unknown"} </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Varicocele</th>
                        <td style={{ width: "30%" }}> {Number(maleForm.Varicocele) === 0 ? "No" : Number(maleForm.Varicocele) === 1 ? "Yes" : Number(maleForm.Varicocele) === 2 ? "Data Not Available" : "Unknown"} </td>
                        <th style={{ width: "20%" }}>Undescended Testes</th>
                        <td style={{ width: "30%" }}> {Number(maleForm.Undescended_Testes) === 0 ? "No" : Number(maleForm.Undescended_Testes) === 1 ? "Yes" : Number(maleForm.Undescended_Testes) === 2 ? "Data Not Available" : "Unknown"} </td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Vasectomy</th>
                        <td style={{ width: "30%" }}> {Number(maleForm.Vasectomy) === 0 ? "No" : Number(maleForm.Vasectomy) === 1 ? "Yes" : Number(maleForm.Vasectomy) === 2 ? "Data Not Available" : "Unknown"} </td>
                        <th style={{ width: "20%" }}>STD / Genital Discharges</th>
                        <td style={{ width: "30%" }}> {Number(maleForm.STD_Genital_Discharges) === 0 ? "No" : Number(maleForm.STD_Genital_Discharges) === 1 ? "Yes" : Number(maleForm.STD_Genital_Discharges) === 2 ? "Data Not Available" : "Unknown"} </td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Genetic Conditions</th>
                        <td style={{ width: "30%" }}>{maleForm.Genetic_Conditions}</td>
                        <th style={{ width: "20%" }}>Others</th>
                        <td style={{ width: "30%" }}>{maleForm.Others}</td>
                    </tr>

                    <tr>
                        <th
                            colSpan={4}
                            style={{
                                fontWeight: "bold",        // makes it bold
                                fontSize: "14pt",          // adjust font size
                                padding: "8px",
                                color: "black"            // add some padding
                            }}
                        >
                            Sexual History
                        </th>
                    </tr>


                    <tr>
                        <th style={{ width: "20%" }}>Erectile Dysfunction</th>
                        <td style={{ width: "30%" }}>
                            {Number(maleForm.execfile_dysfunction) === 2 ? "Data Not Available" : Number(maleForm.execfile_dysfunction) === 0 ? "No" : Number(maleForm.execfile_dysfunction) === 1 ? "Yes" : "Unknown"}
                        </td>
                        <th style={{ width: "20%" }}>Premature Ejaculation</th>
                        <td style={{ width: "30%" }}>
                            {Number(maleForm.execfile_dysfunction) === 2 ? "Data Not Available" : Number(maleForm.pre_mature_ejaculation) === 0 ? "No" : Number(maleForm.pre_mature_ejaculation) === 1 ? "Yes" : "Unknown"}
                        </td>
                    </tr>


                    <tr>
                        <th
                            colSpan={4}
                            style={{
                                fontWeight: "bold",        // makes it bold
                                fontSize: "14pt",          // adjust font size
                                padding: "8px",
                                color: "black"            // add some padding
                            }}
                        >
                            Examination
                        </th>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>General Examination</th>
                        <td style={{ width: "30%" }}>{maleForm.General_Examination || "-"}</td>
                        <th style={{ width: "20%" }}>Local Examination</th>
                        <td style={{ width: "30%" }}>{maleForm.Local_Examination || "-"}</td>
                    </tr>


                    <tr>
                        <th
                            colSpan={4}
                            style={{
                                fontWeight: "bold",        // makes it bold
                                fontSize: "14pt",          // adjust font size
                                padding: "8px",
                                color: "black"            // add some padding
                            }}
                        >
                            Investigation
                        </th>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Blood Group</th>
                        <td style={{ width: "30%" }}>{maleForm.Blood_Group || "-"}</td>
                        <th style={{ width: "20%" }}>Blood Sugar Random</th>
                        <td style={{ width: "30%" }}>{maleForm.Blood_Sugar_R || "-"}</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Blood Sugar Fasting</th>
                        <td style={{ width: "30%" }}>{maleForm.Blood_Sugar_F || "-"}</td>
                        <th style={{ width: "20%" }}>Blood Sugar PP</th>
                        <td style={{ width: "30%" }}>{maleForm.Blood_Sugar_PP || "-"}</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>USG Doppler</th>
                        <td style={{ width: "30%" }}>{maleForm.USG_Doppler || "-"}</td>
                        <th style={{ width: "20%" }}>Karyotyping Analysis</th>
                        <td style={{ width: "30%" }}>{maleForm.Karyotyping_Analysis || "-"}</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Testicular Biopsy</th>
                        <td style={{ width: "30%" }}>{maleForm.Testicular_Biopsy || "-"}</td>
                        <th style={{ width: "20%" }}>Urologist Opinion</th>
                        <td style={{ width: "30%" }}>{maleForm.Urologist_Opinion || "-"}</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>HbA<sub>1</sub>C</th>
                        <td style={{ width: "30%" }}>{maleForm.Hb_Remark || "-"}</td>
                        <th style={{ width: "20%" }}>HBsAg</th>
                        <td style={{ width: "30%" }}>{maleForm.ag_Remark || "-"}</td>
                    </tr>
                    <tr >
                        <th style={{ width: "20%" }}>Others</th>
                        <td colSpan={3}>{maleForm.Others_any || "-"}</td>

                    </tr>

                    <tr>
                        <th
                            colSpan={4}
                            style={{
                                fontWeight: "bold",        // makes it bold
                                fontSize: "14pt",          // adjust font size
                                padding: "8px",
                                color: "black"            // add some padding
                            }}
                        >
                            Liver Function Tests
                        </th>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>ALT</th>
                        <td style={{ width: "30%" }}>{maleForm.ALT || "-"} u/l</td>
                        <th style={{ width: "20%" }}>ALP</th>
                        <td style={{ width: "30%" }}>{maleForm.ALP || "-"} u/l</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>AST</th>
                        <td style={{ width: "30%" }}>{maleForm.AST || "-"} u/l</td>
                        <th style={{ width: "20%" }}>AST:ALT</th>
                        <td style={{ width: "30%" }}>{maleForm.AST_ALT || "-"} u/l</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>GGT</th>
                        <td style={{ width: "30%" }}>{maleForm.GTT || "-"} u/l</td>
                        <th style={{ width: "20%" }}>Total Bilirubin</th>
                        <td style={{ width: "30%" }}>{maleForm.Total_Bilirubin || "-"} mg/dl</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Direct Bilirubin</th>
                        <td style={{ width: "30%" }}>{maleForm.Direct_Bilirubin || "-"} mg/dl</td>
                        <th style={{ width: "20%" }}>Indirect Bilirubin</th>
                        <td style={{ width: "30%" }}>{maleForm.Indirect_Bilirubin || "-"} mg/dl</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Total Plasma Protein</th>
                        <td style={{ width: "30%" }}>{maleForm.Total_Plastma_Protein || "-"} g/dl</td>
                        <th style={{ width: "20%" }}>Albumin</th>
                        <td style={{ width: "30%" }}>{maleForm.Albumin || "-"} g/dl</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Globulin</th>
                        <td style={{ width: "30%" }}>{maleForm.Globulin || "-"} g/dl</td>
                        <th style={{ width: "20%" }}>Albumin/Globulin Ratio</th>
                        <td style={{ width: "30%" }}>{maleForm.Albumin_Globulin_Ratio || "-"}</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Remark</th>
                        <td colSpan={3}>{maleForm.Liver_Test_remark || "-"}</td>
                    </tr>

                    <tr>
                        <th
                            colSpan={4}
                            style={{
                                fontWeight: "bold",       
                                fontSize: "14pt",          
                                padding: "8px",
                                color: "black"            
                            }}
                        >
                            Lipid Profile
                        </th>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Total Cholesterol</th>
                        <td style={{ width: "30%" }}>{maleForm.Total_Cholesterol || "-"} mg/dl</td>
                        <th style={{ width: "20%" }}>LDL Cholesterol</th>
                        <td style={{ width: "30%" }}>{maleForm.LDL_Cholesterol || "-"} mg/dl</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>HDL Cholesterol</th>
                        <td style={{ width: "30%" }}>{maleForm.HDL_Cholesterol || "-"} mg/dl</td>
                        <th style={{ width: "20%" }}>VLDL Cholesterol</th>
                        <td style={{ width: "30%" }}>{maleForm.VLDL_Cholesterol || "-"} mg/dl</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Triglycerides</th>
                        <td style={{ width: "30%" }}>{maleForm.Triglycerides || "-"} mg/dl</td>
                        <th style={{ width: "20%" }}>Total cholesterol to HDL ratio</th>
                        <td style={{ width: "30%" }}>{maleForm.Total_cholesterol_HDL_ratio || "-"}</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>LDL to HDL ratio</th>
                        <td style={{ width: "30%" }}>{maleForm.LDL_to_HDL_ratio || "-"}</td>
                        <th style={{ width: "20%" }}>Non-HDL cholesterol</th>
                        <td style={{ width: "30%" }}>{maleForm.Non_HDL_cholesterol || "-"} mg/dl</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Remark</th>
                        <td colSpan={3}>{maleForm.Lipid_Profile_remark || "-"}</td>
                    </tr>
                    <tr>
                        <th
                            colSpan={4}
                            style={{
                                fontWeight: "bold",        // makes it bold
                                fontSize: "14pt",          // adjust font size
                                padding: "8px",
                                color: "black"            // add some padding
                            }}
                        >
                            Body Composition Analysis
                        </th>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Total Body Water</th>
                        <td style={{ width: "30%" }}>{maleForm.Total_Body_Water || "-"} Litre</td>
                        <th style={{ width: "20%" }}>Protein</th>
                        <td style={{ width: "30%" }}>{maleForm.Protein || "-"} Kg</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Minerals</th>
                        <td style={{ width: "30%" }}>{maleForm.Minerals || "-"} kg</td>
                        <th style={{ width: "20%" }}>Body Fat Mass</th>
                        <td style={{ width: "30%" }}>{maleForm.Body_Fat_Mass || "-"} kg</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Soft Lean Mass</th>
                        <td style={{ width: "30%" }}>{maleForm.Soft_Lean_Mass || "-"} kg</td>
                        <th style={{ width: "20%" }}>Fat Free Mass</th>
                        <td style={{ width: "30%" }}>{maleForm.Fat_Free_Mass || "-"} kg</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Body Weight</th>
                        <td style={{ width: "30%" }}>{maleForm.Body_Weight || "-"} kg</td>
                        <th style={{ width: "20%" }}>Height</th>
                        <td style={{ width: "30%" }}>{maleForm.Height || "-"} cm</td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Remark</th>
                        <td colSpan={3}>{maleForm.Body_Composition_remark || "-"}</td>
                    </tr>

                    <tr>
                        <th
                            colSpan={4}
                            style={{
                                fontWeight: "bold",        // makes it bold
                                fontSize: "14pt",          // adjust font size
                                padding: "8px",
                                color: "black"            // add some padding
                            }}
                        >
                            Muscle Fat Analysis
                        </th>
                    </tr>


                    <tr>
                        <th style={{ width: "20%" }}>Weight</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Weight || "-"} kg
                        </td>

                        <th style={{ width: "20%" }}>Skeletal Muscle Mass (SMM)</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Skeletal_Muscle_Mass || "-"} kg
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Body Fat Mass</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Body_Fat_Mass_muscle || "-"} kg
                        </td>

                        <th style={{ width: "20%" }}>Body Fat Percent</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Body_Fat_Percent || "-"} %
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Remark</th>
                        <td colSpan={3}>
                            {maleForm.Body_muscle_remark || "-"}
                        </td>
                    </tr>
                    <tr>
                        <th
                            colSpan={4}
                            style={{
                                fontWeight: "bold",        // makes it bold
                                fontSize: "14pt",          // adjust font size
                                padding: "8px",
                                color: "black"            // add some padding
                            }}
                        >
                            Obesity Analysis
                        </th>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>BMI</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.BMI_Obesity || "-"} kg/m<sup>2</sup>
                        </td>

                        <th style={{ width: "20%" }}>Percent Body Fat (PBF)</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Percent_Body_Fat || "-"} Kg
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Remark</th>
                        <td colSpan={3}>
                            {maleForm.obesity_remark || "-"}
                        </td>
                    </tr>
                    <tr>
                        <th
                            colSpan={4}
                            style={{
                                fontWeight: "bold",        // makes it bold
                                fontSize: "14pt",          // adjust font size
                                padding: "8px",
                                color: "black"            // add some padding
                            }}
                        >
                            Segmental Lean Analysis

                        </th>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Right Arm (Lean Mass kg)</th>
                        <td style={{ width: "30%" }}>{maleForm.Right_Arm_Lean_Mass_kg || "-"} kg</td>
                        <th style={{ width: "20%" }}>Right Arm (Lean Mass %)</th>
                        <td style={{ width: "30%" }}>{maleForm.Right_Arm_Lean_Mass_percent || "-"} %</td>

                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Right Arm (ECW Ratio)</th>
                        <td style={{ width: "30%" }}>{maleForm.Right_Arm_ECW_Ratio || "-"}</td>
                        <th style={{ width: "20%" }}>Left Arm (Lean Mass kg)</th>
                        <td style={{ width: "30%" }}>{maleForm.Left_Arm_Lean_Mass_kg || "-"} kg</td>
                    </tr>
                    <tr>

                        <th style={{ width: "20%" }}>Left Arm (Lean Mass %)</th>
                        <td style={{ width: "30%" }}>{maleForm.Left_Arm_Lean_Mass_percent || "-"} %</td>
                        <th style={{ width: "20%" }}>Left Arm (ECW Ratio)</th>
                        <td style={{ width: "30%" }}>{maleForm.Left_Arm_ECW_Ratio || "-"}</td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Trunk (Lean Mass kg)</th>
                        <td style={{ width: "30%" }}>{maleForm.Trunk_Lean_Mass_kg || "-"} kg</td>
                        <th style={{ width: "20%" }}>Trunk (Lean Mass %)</th>
                        <td style={{ width: "30%" }}>{maleForm.Trunk_Lean_Mass_percent || "-"} %</td>

                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Trunk (ECW Ratio)</th>
                        <td style={{ width: "30%" }}>{maleForm.Trunk_ECW_Ratio || "-"}</td>
                        <th style={{ width: "20%" }}>Right Leg (Lean Mass kg)</th>
                        <td style={{ width: "30%" }}>{maleForm.Right_Leg_Lean_Mass_kg || "-"} kg</td>
                    </tr>
                    <tr>

                        <th style={{ width: "20%" }}>Right Leg (Lean Mass %)</th>
                        <td style={{ width: "30%" }}>{maleForm.Right_Leg_Lean_Mass_percent || "-"} %</td>
                        <th style={{ width: "20%" }}>Right Leg (ECW Ratio)</th>
                        <td style={{ width: "30%" }}>{maleForm.Right_Leg_ECW_Ratio || "-"}</td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Left Leg (Lean Mass kg)</th>
                        <td style={{ width: "30%" }}>{maleForm.Left_Leg_Lean_Mass_kg || "-"} kg</td>
                        <th style={{ width: "20%" }}>Left Leg (Lean Mass %)</th>
                        <td style={{ width: "30%" }}>{maleForm.Left_Leg_Lean_Mass_percent || "-"} %</td>

                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Left Leg (ECW Ratio)</th>
                        <td style={{ width: "30%" }}>{maleForm.Left_Leg_ECW_Ratio || "-"}</td>
                        <th style={{ width: "20%" }}>Remark</th>
                        <td colSpan={5}>{maleForm.Segmental_remark || "-"}</td>
                    </tr>


                    <tr>
                        <th
                            colSpan={4}
                            style={{
                                fontWeight: "bold",
                                fontSize: "14pt",
                                padding: "8px",
                                color: "black"
                            }}
                        >
                            Segmental Fat Analysis
                        </th>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Right Arm (Fat Mass kg)</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Right_Arm_Fat_Mass_kg || "-"} kg
                        </td>

                        <th style={{ width: "20%" }}>Right Arm (Fat Mass %)</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Right_Arm_Fat_Mass_percent || "-"} %
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Left Arm (Fat Mass kg)</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Left_Arm_Fat_Mass_kg || "-"} kg
                        </td>

                        <th style={{ width: "20%" }}>Left Arm (Fat Mass %)</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Left_Arm_Fat_Mass_percent || "-"} %
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Trunk (Fat Mass kg)</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Trunk_Fat_Mass_kg || "-"} kg
                        </td>

                        <th style={{ width: "20%" }}>Trunk (Fat Mass %)</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Trunk_Fat_Mass_percent || "-"} %
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Right Leg (Fat Mass kg)</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Right_Leg_Fat_Mass_kg || "-"} kg
                        </td>

                        <th style={{ width: "20%" }}>Right Leg (Fat Mass %)</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Right_Leg_Fat_Mass_percent || "-"} %
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Left Leg (Fat Mass kg)</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Left_Leg_Fat_Mass_kg || "-"} kg
                        </td>

                        <th style={{ width: "20%" }}>Left Leg (Fat Mass %)</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Left_Leg_Fat_Mass_percent || "-"} %
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Remark</th>
                        <td colSpan={3}>
                            {maleForm.Segmental_fat_remark || "-"}
                        </td>
                    </tr>
                    <tr>
                        <th
                            colSpan={4}
                            style={{
                                fontWeight: "bold",
                                fontSize: "14pt",
                                padding: "8px",
                                color: "black"
                            }}
                        >
                            Miscellaneous
                        </th>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>In Body Score</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.In_Body_Score || "-"} /100<sup>Points</sup>
                        </td>

                        <th style={{ width: "20%" }}>Visceral Fat Area</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Visceral_Fat_Area || "-"} cm<sup>2</sup>
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Whole Body Phase Angle</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Whole_Body_Phase_Angle || "-"} <sup>o</sup>
                        </td>

                        <th style={{ width: "20%" }}>Intracellular Water</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Intracellular_Water || "-"} Litre
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Extracellular Water</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Extracellular_Water || "-"} Litre
                        </td>

                        <th style={{ width: "20%" }}>Basal Metabolic Rate</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Basal_Metabolic_Rate || "-"} kcal
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>SMI (Sarcopenia)</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.SMI_Sarcopenia || "-"} kg/m<sup>2</sup>
                        </td>

                        <th style={{ width: "20%" }}>HGS (Sarcopenia)</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.HGS_Sarcopenia || "-"} kg
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Remark</th>
                        <td colSpan={3}>
                            {maleForm.Miscellaneous_remark || "-"}
                        </td>
                    </tr>
                    <tr>
                        <th
                            colSpan={4}
                            style={{
                                fontWeight: "bold",
                                fontSize: "14pt",
                                padding: "8px",
                                color: "black"
                            }}
                        >
                            Semen Analysis (Pre-Preparation)
                        </th>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Date of Sample Collection</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Date_of_Sample || "-"}
                        </td>

                        <th style={{ width: "20%" }}>Ejaculatory Abstinence</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Ejaculatory_Abstinence || "-"} days
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Semen Volume</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Semen_Volume || "-"} ml
                        </td>

                        <th style={{ width: "20%" }}>Color</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Color || "-"}
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Appearance</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Appearance || "-"}
                        </td>

                        <th style={{ width: "20%" }}>Liquefaction Time</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Liquifcation_Time || "-"} min {maleForm.Liquifcation_Remark || ""}
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Viscosity</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Viscosity || "-"}
                        </td>

                        <th style={{ width: "20%" }}>pH</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.pH || "-"}
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Sperm Concentration</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Semen_Concentration || "-"} million/ml
                        </td>

                        <th style={{ width: "20%" }}>Total Sperm Count</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Total_Sperm_Count || "-"} million/ejaculate
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Total Progressive Motile Sperm Count</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Count_Motile_Sperm || "-"} million/ejaculate
                        </td>

                        <th style={{ width: "20%" }}>Progressive Motility PR</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Progressive_Motility_Rate || "-"} %
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Non Progressive Motility</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.NonP_Motility || "-"} %
                        </td>

                        <th style={{ width: "20%" }}>Total Motility</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Total_Motility || "-"} %
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Immotile</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Immotile || "-"} %
                        </td>

                        <th style={{ width: "20%" }}>Vitality</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Vitality || "-"} %
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Normal Sperm Morphology</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Normal_Sperm_Morphology || "-"} %
                        </td>

                        <th style={{ width: "20%" }}>Abnormal Heads</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Abnormal_Heads || "-"} %
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Abnormal Neck & Midpiece</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Abnormal_NandM || "-"} %
                        </td>

                        <th style={{ width: "20%" }}>Abnormal Tail</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Abnormal_Tail || "-"} %
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Extra Cytoplasmic Residue</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Extra_cytoplasmic || "-"} %
                        </td>

                        <th style={{ width: "20%" }}>Qualitative Fructose</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Qualitative_Fructose || "-"}
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Aggregation</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Aggregation || "-"}
                        </td>

                        <th style={{ width: "20%" }}>Agglutination</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Agglutination || "-"}
                        </td>
                    </tr>
                    <tr>
                        <th
                            colSpan={4}
                            style={{
                                fontWeight: "bold",
                                fontSize: "14pt",
                                padding: "8px",
                                color: "black"
                            }}
                        >
                            Semen Analysis (Post-Preparation)
                        </th>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Sperm Concentration</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Semen_Concentration_post || "-"} million/ml
                        </td>

                        <th style={{ width: "20%" }}>Total Sperm Count</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Total_Sperm_Count_post || "-"} million/sample volume
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Progressive Motility PR</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Progressive_Motility_Rate_post || "-"} %
                        </td>

                        <th style={{ width: "20%" }}>Non Progressive Motility</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.NonP_Motility_post || "-"} %
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Total Motility</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Total_Motility_post || "-"} %
                        </td>

                        <th style={{ width: "20%" }}>Immotile</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Immotile_post || "-"} %
                        </td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Normal Sperm Morphology</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Normal_Sperm_Morphology_post || "-"} %
                        </td>

                        <th style={{ width: "20%" }}>Abnormal Heads</th>
                        <td style={{ width: "30%" }}>
                            {maleForm.Abnormal_Heads_post || "-"} %
                        </td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>Round Cells</th>
                        <td style={{ width: "30%" }}>{maleForm.Round_Cells || "-"}</td>

                        <th style={{ width: "20%" }}>Epithelial Cells</th>
                        <td style={{ width: "30%" }}>{maleForm.Epithelial_Cells || "-"}</td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Other Cells</th>
                        <td style={{ width: "30%" }}>{maleForm.Other_Cells || "-"}</td>

                        <th style={{ width: "20%" }}>RSA Report</th>
                        <td style={{ width: "30%" }}>{maleForm.RSA_Report || "-"}</td>
                    </tr>

                    <tr>
                        <th style={{ width: "20%" }}>Other Remarks</th>
                        <td colSpan={3}>
                            {maleForm.Other_Remarks || "-"}
                        </td>
                    </tr>
                </tbody>

            </table>



            {/* Male Hormonal */}
            <h4 className="mt-4">Male Hormonal Assay</h4>
            <table className="print-table">
                <thead>
                    <tr>
                        <th >Date</th>
                        <th >FSH</th>
                        <th >LH</th>
                        <th >Testosterone</th>
                        <th >Prolactin</th>
                        <th >FT4</th>
                        <th >FT3</th>
                        <th >TSH</th>
                    </tr>
                </thead>
                <tbody>
                    {maleHormonalRows.map((row, i) => (
                        <tr key={i}>

                            <td >{row.assay_date}</td>
                            <td >{row.FSH}</td>
                            <td >{row.LH}</td>
                            <td >{row.Testosterone}</td>
                            <td >{row.Prolactin}</td>
                            <td >{row.FT4}</td>
                            <td >{row.FT3}</td>
                            <td>{row.TSH}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {/* Female Details */}
            {
                femaleForm?.Patient_Name && (
                    <>
                        <h4 className="mt-4">Female Details</h4>
                        <table className="print-table">
                            <tbody>
                                <tr>
                                    <th style={{ width: "20%" }}>CRN No</th>
                                    <td style={{ width: "30%" }}>{femaleForm.CRN_No || "-"}</td>

                                    <th style={{ width: "20%" }}>Infertility Reg No</th>
                                    <td style={{ width: "30%" }}>{femaleForm.Infertility_Reg_no || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Patient Name</th>
                                    <td>{femaleForm.Patient_Name || "-"}</td>

                                    <th>Sample ID</th>
                                    <td>{femaleForm.sample_id || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Date</th>
                                    <td>{femaleForm.reg_date || "-"}</td>

                                    <th>Age</th>
                                    <td>{femaleForm.Age || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Address</th>
                                    <td>{femaleForm.address || "-"}</td>

                                    <th>Occupation</th>
                                    <td>{femaleForm.Occupation || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Referral By</th>
                                    <td colSpan={3}>{femaleForm.refrred_by || "-"}</td>
                                </tr>
                                <tr>
                                    <th
                                        colSpan={4}
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "14pt",
                                            padding: "8px",
                                            color: "black"
                                        }}
                                    >
                                        History of Drug Allergy
                                    </th>
                                </tr>

                                <tr>
                                    <th>Drug Allergy</th>
                                    <td colSpan={3}>{femaleForm.Drug_Allergy || "-"}</td>
                                </tr>
                                <tr>
                                    <th
                                        colSpan={4}
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "14pt",
                                            padding: "8px",
                                            color: "black"
                                        }}
                                    >
                                        Obstetric History
                                    </th>
                                </tr>

                                <tr>
                                    <th>Married Since</th>
                                    <td>{femaleForm.Married_Since || "-"}</td>

                                    <th>Infertility Duration</th>
                                    <td>{femaleForm.Infertility_Duration || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Type of Infertility</th>
                                    <td>{femaleForm.Primary_Infertility || "-"}</td>

                                    <th>Obstetric History</th>
                                    <td>{femaleForm.Obstetric_History || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Other Remarks</th>
                                    <td colSpan={3}>{femaleForm.Other_Remarks || "-"}</td>
                                </tr>
                                <tr>
                                    <th
                                        colSpan={4}
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "14pt",
                                            padding: "8px",
                                            color: "black"
                                        }}
                                    >
                                        Menstrual History
                                    </th>
                                </tr>

                                <tr>
                                    <th>Age at Menarche</th>
                                    <td>{femaleForm.Age_at_Menarche || "-"}</td>

                                    <th>Day of Current Cycle</th>
                                    <td>{femaleForm.Day_of_MC || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Previous Cycle</th>
                                    <td>{femaleForm.Previous_Cycle || "-"}</td>

                                    <th>Last MC (LMP)</th>
                                    <td>{femaleForm.Last_MC || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Menstrual Loss</th>
                                    <td>{femaleForm.Menstrual_Loss || "-"}</td>

                                    <th>Dysmenorrhea</th>
                                    <td>{femaleForm.Dysmenorrhea || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Postcoital Bleeding</th>
                                    <td>{femaleForm.Postcoital_Bleeding || "-"}</td>

                                    <th>Intermenstrual Bleeding</th>
                                    <td>{femaleForm.Intermenstrual_Bleeding || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Remarks</th>
                                    <td colSpan={3}>{femaleForm.Menstural_Remarks || "-"}</td>
                                </tr>
                                <tr>
                                    <th
                                        colSpan={4}
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "14pt",
                                            padding: "8px",
                                            color: "black"
                                        }}
                                    >
                                        Sexual History
                                    </th>
                                </tr>

                                <tr>
                                    <th>Intercourse Type</th>
                                    <td>{femaleForm.Intercourse_type || "-"}</td>

                                    <th>Intercourse Frequency</th>
                                    <td>{femaleForm.Intercourse_Frequency || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Dyspareunia</th>
                                    <td>{femaleForm.Dyspareunia || "-"}</td>
                                </tr>
                                <tr>
                                    <th
                                        colSpan={4}
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "14pt",
                                            padding: "8px",
                                            color: "black"
                                        }}
                                    >
                                        Other Important History
                                    </th>
                                </tr>

                                <tr>
                                    <th>Hirsutism</th>
                                    <td>{femaleForm.Hirsutism || "-"}</td>

                                    <th>Acanthosis Nigricans</th>
                                    <td>{femaleForm.Acanthosis_Nigricans || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Galactorrhoea</th>
                                    <td>{femaleForm.Galactorrhoea || "-"}</td>

                                    <th>Rubella Vaccination</th>
                                    <td>{femaleForm.Rubella_Vaccination || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Consanguineous Marriage</th>
                                    <td>{femaleForm.Consanguineous_Marriage || "-"}</td>

                                    <th>Contraceptive Method</th>
                                    <td>{femaleForm.Contraceptive_Method || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Remarks</th>
                                    <td colSpan={3}>{femaleForm.History_Remarks || "-"}</td>
                                </tr>

                                <tr>
                                    <th
                                        colSpan={4}
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "14pt",
                                            padding: "8px",
                                            color: "black"
                                        }}
                                    >
                                        Medical History
                                    </th>
                                </tr>

                                <tr>
                                    <th>Hypertension</th>
                                    <td>{femaleForm.Hypertension || "-"}</td>

                                    <th>Medication</th>
                                    <td>{femaleForm.Medication_Hypertension || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Diabetes</th>
                                    <td>{femaleForm.Diabetes || "-"}</td>

                                    <th>Medication</th>
                                    <td>{femaleForm.Medication_Diabetes || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Thyroid</th>
                                    <td>{femaleForm.Thyroid || "-"}</td>

                                    <th>Medication</th>
                                    <td>{femaleForm.Medication_Thyroid || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Cardiac</th>
                                    <td>{femaleForm.Cardiac_Disease || "-"}</td>

                                    <th>Drugs</th>
                                    <td>{femaleForm.Drugs_Cardiac_Disease || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Medication</th>
                                    <td>{femaleForm.Medication_Cardiac_Disease || "-"}</td>

                                    <th>Remarks</th>
                                    <td>{femaleForm.Medical_Remarks || "-"}</td>
                                </tr>
                                <tr>
                                    <th
                                        colSpan={4}
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "14pt",
                                            padding: "8px",
                                            color: "black"
                                        }}
                                    >
                                        Surgical History
                                    </th>
                                </tr>

                                <tr>
                                    <th>Surgical History</th>
                                    <td colSpan={3}>{femaleForm.Surgical_History || "-"}</td>
                                </tr>
                                <tr>
                                    <th
                                        colSpan={4}
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "14pt",
                                            padding: "8px",
                                            color: "black"
                                        }}
                                    >
                                        Family History
                                    </th>
                                </tr>

                                <tr>
                                    <th>Family History</th>
                                    <td colSpan={3}>{femaleForm.Family_History || "-"}</td>
                                </tr>
                                <tr>
                                    <th
                                        colSpan={4}
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "14pt",
                                            padding: "8px",
                                            color: "black"
                                        }}
                                    >
                                        Treatment History
                                    </th>
                                </tr>

                                <tr>
                                    <th>Ovulation Induction Drugs</th>
                                    <td>{femaleForm.Ovulation_Induction_Drugs || "-"}</td>

                                    <th>No. Of Prior IUI</th>
                                    <td>{femaleForm.IUI || "-"}</td>
                                </tr>

                                <tr>
                                    <th>No. Of Prior IVF</th>
                                    <td>{femaleForm.Prior_IVF || "-"}</td>

                                    <th>Remarks</th>
                                    <td>{femaleForm.Treatment_Remarks || "-"}</td>
                                </tr>
                                <tr>
                                    <th
                                        colSpan={4}
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "14pt",
                                            padding: "8px",
                                            color: "black"
                                        }}
                                    >
                                        Examination Findings
                                    </th>
                                </tr>

                                <tr>
                                    <th>Height</th>
                                    <td>{femaleForm.Height || "-"} cm</td>

                                    <th>Weight</th>
                                    <td>{femaleForm.Weight || "-"} kg</td>
                                </tr>

                                <tr>
                                    <th>BMI</th>
                                    <td>{femaleForm.BMI || "-"}</td>

                                    <th>Waist Hip Ratio</th>
                                    <td>{femaleForm.Waist_Hip_Ratio || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Respiratory System Exam</th>
                                    <td>{femaleForm.Respiratory_System_Examination || "-"}</td>

                                    <th>CVS Examination</th>
                                    <td>{femaleForm.CVS_Examination || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Breast Examination</th>
                                    <td>{femaleForm.Breast_Examination || "-"}</td>

                                    <th>Local Examination</th>
                                    <td>{femaleForm.Local_Examination || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Per Abdomen Exam</th>
                                    <td>{femaleForm.Per_Abdomen_Exam || "-"}</td>

                                    <th>Per Vaginal Exam</th>
                                    <td>{femaleForm.Per_Vaginal_Exam || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Per Speculum Exam</th>
                                    <td colSpan={3}>{femaleForm.Per_Speculum_Exam || "-"}</td>
                                </tr>
                                <tr>
                                    <th
                                        colSpan={4}
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "14pt",
                                            padding: "8px",
                                            color: "black"
                                        }}
                                    >
                                        Blood Pressure
                                    </th>
                                </tr>

                                <tr>
                                    <th>SBP</th>
                                    <td>{femaleForm.Blood_Pressure || "-"} mm/Hg</td>

                                    <th>DBP</th>
                                    <td>{femaleForm.Blood_Pressure_DBP || "-"} mm/Hg</td>
                                </tr>
                                <tr>
                                    <th
                                        colSpan={4}
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "14pt",
                                            padding: "8px",
                                            color: "black"
                                        }}
                                    >
                                        Investigation
                                    </th>
                                </tr>

                                <tr>
                                    <th>Blood Group</th>
                                    <td>{femaleForm.Blood_Group || "-"}</td>

                                    <th>CBC</th>
                                    <td>{femaleForm.CBC || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Blood Sugar</th>
                                    <td>{femaleForm.Blood_Sugar_R || "-"}</td>

                                    <th>HbA1C</th>
                                    <td>{femaleForm.HbA1C || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Hb Electrophoresis</th>
                                    <td>{femaleForm.Hb_Electrophoresis || "-"}</td>

                                    <th>TORCH</th>
                                    <td>{femaleForm.TORCH || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Thrombophilia Profile</th>
                                    <td>{femaleForm.Thrombophilia_Profile || "-"}</td>

                                    <th>Cervical Smear</th>
                                    <td>{femaleForm.Cervical_Smear || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Karyotyping (POCs)</th>
                                    <td>{femaleForm.Karyotyping || "-"}</td>

                                    <th>Karyotyping Wife</th>
                                    <td>{femaleForm.Karyotyping_Wife || "-"}</td>
                                </tr>

                                <tr>
                                    <th>HIV</th>
                                    <td>{femaleForm.HIV || "-"}</td>

                                    <th>HCV</th>
                                    <td>{femaleForm.HCV || "-"}</td>
                                </tr>

                                <tr>
                                    <th>HBsAg</th>
                                    <td>{femaleForm.HBsAg || "-"}</td>

                                    <th>HSG</th>
                                    <td>{femaleForm.HSG || "-"}</td>
                                </tr>

                                <tr>
                                    <th>VDRL</th>
                                    <td>{femaleForm.VDRL_Aldo || "-"}</td>

                                    <th>Remark</th>
                                    <td>{femaleForm.investigation_remark || "-"}</td>
                                </tr>
                                <tr>
                                    <th
                                        colSpan={4}
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "14pt",
                                            padding: "8px",
                                            color: "black"
                                        }}
                                    >
                                        Investigation
                                    </th>
                                </tr>

                                <tr>
                                    <th>Blood Group</th>
                                    <td>{femaleForm.Blood_Group || "-"}</td>

                                    <th>CBC</th>
                                    <td>{femaleForm.CBC || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Blood Sugar</th>
                                    <td>{femaleForm.Blood_Sugar_R || "-"}</td>

                                    <th>HbA1C</th>
                                    <td>{femaleForm.HbA1C || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Hb Electrophoresis</th>
                                    <td>{femaleForm.Hb_Electrophoresis || "-"}</td>

                                    <th>TORCH</th>
                                    <td>{femaleForm.TORCH || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Thrombophilia Profile</th>
                                    <td>{femaleForm.Thrombophilia_Profile || "-"}</td>

                                    <th>Cervical Smear</th>
                                    <td>{femaleForm.Cervical_Smear || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Karyotyping (POCs)</th>
                                    <td>{femaleForm.Karyotyping || "-"}</td>

                                    <th>Karyotyping Wife</th>
                                    <td>{femaleForm.Karyotyping_Wife || "-"}</td>
                                </tr>

                                <tr>
                                    <th>HIV</th>
                                    <td>{femaleForm.HIV || "-"}</td>

                                    <th>HCV</th>
                                    <td>{femaleForm.HCV || "-"}</td>
                                </tr>

                                <tr>
                                    <th>HBsAg</th>
                                    <td>{femaleForm.HBsAg || "-"}</td>

                                    <th>HSG</th>
                                    <td>{femaleForm.HSG || "-"}</td>
                                </tr>

                                <tr>
                                    <th>VDRL</th>
                                    <td>{femaleForm.VDRL_Aldo || "-"}</td>

                                    <th>Remark</th>
                                    <td>{femaleForm.investigation_remark || "-"}</td>
                                </tr>
                            </tbody>
                        </table>
                    </>
                )
            }
            {/* Female Hormonal */}
            <h4 className="mt-4">Female Hormonal Assay</h4>
            <table className="print-table">
                <thead>
                    <tr>
                        <th>AMH</th>
                        <th>FSH</th>
                        <th>LH</th>
                        <th>Estradiol</th>
                        <th>Progesterone</th>
                        <th>TSH</th>
                        <th>Prolactin</th>
                    </tr>
                </thead>
                <tbody>
                    {femaleHormonalRows.map((row, i) => (
                        <tr key={i}>
                            <td >{row.AMH}</td>
                            <td >{row.FSH}</td>
                            <td >{row.LH}</td>
                            <td >{row.Estradiol}</td>
                            <td >{row.Progesterone}</td>
                            <td >{row.TSH}</td>
                            <td >{row.Prolactin}</td>

                        </tr>
                    ))}
                </tbody>
            </table>


            <>
                <h4 className="mt-4">PIWIL mRNA Expression</h4>

                <table className="print-table">
                    <tbody>

                        {/* Header */}
                        <tr>
                            <th style={{ width: "30%" }}></th>
                            <th style={{ width: "35%" }}>Avg Ct</th>
                            <th style={{ width: "35%" }}>Copies of mRNA</th>
                        </tr>

                        {/* PIWIL 1 */}
                        <tr>
                            <th>PIWIL 1 mRNA</th>
                            <td>{PiwilMrnaModel.piwil1_avg || "-"}</td>
                            <td>{PiwilMrnaModel.piwil1_copies || "-"}</td>
                        </tr>

                        {/* PIWIL 2 */}
                        <tr>
                            <th>PIWIL 2 mRNA</th>
                            <td>{PiwilMrnaModel.piwil2_avg || "-"}</td>
                            <td>{PiwilMrnaModel.piwil2_copies || "-"}</td>
                        </tr>

                        {/* PIWIL 3 */}
                        <tr>
                            <th>PIWIL 3 mRNA</th>
                            <td>{PiwilMrnaModel.piwil3_avg || "-"}</td>
                            <td>{PiwilMrnaModel.piwil3_copies || "-"}</td>
                        </tr>

                        {/* PIWIL 4 */}
                        <tr>
                            <th>PIWIL 4 mRNA</th>
                            <td>{PiwilMrnaModel.piwil4_avg || "-"}</td>
                            <td>{PiwilMrnaModel.piwil4_copies || "-"}</td>
                        </tr>

                        <tr>
                            <th style={{ width: "30%" }}></th>
                            <th style={{ width: "35%" }}>Slope (m)
                            </th>
                            <th style={{ width: "35%" }}>Y intercept (b)
                            </th>
                        </tr>

                        {/* PIWIL 1 */}
                        <tr>
                            <th>PIWIL 1 Std</th>
                            <td>{PiwilMrnaModel.piwil1_slope || "-"}</td>
                            <td>{PiwilMrnaModel.piwil1_intercempt || "-"}</td>
                        </tr>

                        {/* PIWIL 2 */}
                        <tr>
                            <th>PIWIL 2 Std</th>
                            <td>{PiwilMrnaModel.piwil2_slope || "-"}</td>
                            <td>{PiwilMrnaModel.piwil2_intercempt || "-"}</td>
                        </tr>

                        {/* PIWIL 3 */}
                        <tr>
                            <th>PIWIL 3 Std</th>
                            <td>{PiwilMrnaModel.piwil3_slope || "-"}</td>
                            <td>{PiwilMrnaModel.piwil3_intercempt || "-"}</td>
                        </tr>

                        {/* PIWIL 4 */}
                        <tr>
                            <th>PIWIL 4 Std</th>
                            <td>{PiwilMrnaModel.piwil4_slope || "-"}</td>
                            <td>{PiwilMrnaModel.piwil4_intercempt || "-"}</td>
                        </tr>

                        {/* Remark */}
                        <tr>
                            <th>Remark</th>
                            <td colSpan={2}>{PiwilMrnaModel.remark || "-"}</td>
                        </tr>

                    </tbody>
                </table>
            </>
            <>
                <h4 className="mt-4">PIWIL Protein Expression</h4>

                <table className="print-table">
                    <tbody>

                        {/* Header */}
                        <tr>
                            <th style={{ width: "30%" }}></th>
                            <th style={{ width: "35%" }}>OD (Avg)</th>
                            <th style={{ width: "35%" }}>Conc (pg/mL)</th>
                        </tr>

                        {/* PIWIL 1 */}
                        <tr>
                            <th>PIWIL 1 Protein</th>
                            <td>{ProteinModel.piwil1_avg || "-"}</td>
                            <td>{ProteinModel.piwil1_copies || "-"}</td>
                        </tr>

                        {/* PIWIL 2 */}
                        <tr>
                            <th>PIWIL 2 Protein</th>
                            <td>{ProteinModel.piwil2_avg || "-"}</td>
                            <td>{ProteinModel.piwil2_copies || "-"}</td>
                        </tr>

                        {/* PIWIL 3 */}
                        <tr>
                            <th>PIWIL 3 Protein</th>
                            <td>{ProteinModel.piwil3_avg || "-"}</td>
                            <td>{ProteinModel.piwil3_copies || "-"}</td>
                        </tr>

                        {/* PIWIL 4 */}
                        <tr>
                            <th>PIWIL 4 Protein</th>
                            <td>{ProteinModel.piwil4_avg || "-"}</td>
                            <td>{ProteinModel.piwil4_copies || "-"}</td>
                        </tr>


                        {/* Second Header */}
                        <tr>
                            <th></th>
                            <th>Slope (m)</th>
                            <th>Y intercept (b)</th>
                        </tr>

                        {/* PIWIL 1 Std */}
                        <tr>
                            <th>PIWIL 1 Std</th>
                            <td>{ProteinModel.piwil1_slope || "-"}</td>
                            <td>{ProteinModel.piwil1_intercempt || "-"}</td>
                        </tr>

                        {/* PIWIL 2 Std */}
                        <tr>
                            <th>PIWIL 2 Std</th>
                            <td>{ProteinModel.piwil2_slope || "-"}</td>
                            <td>{ProteinModel.piwil2_intercempt || "-"}</td>
                        </tr>

                        {/* PIWIL 3 Std */}
                        <tr>
                            <th>PIWIL 3 Std</th>
                            <td>{ProteinModel.piwil3_slope || "-"}</td>
                            <td>{ProteinModel.piwil3_intercempt || "-"}</td>
                        </tr>

                        {/* PIWIL 4 Std */}
                        <tr>
                            <th>PIWIL 4 Std</th>
                            <td>{ProteinModel.piwil4_slope || "-"}</td>
                            <td>{ProteinModel.piwil4_intercempt || "-"}</td>
                        </tr>

                        {/* Remark */}
                        <tr>
                            <th>Remark</th>
                            <td colSpan={2}>{ProteinModel.remark || "-"}</td>
                        </tr>

                    </tbody>
                </table>
            </>
            <>
                <h4 className="mt-4">DFI Data - SCD Kit</h4>

                <table className="print-table">
                    <tbody>

                        {/* Halo Counts */}
                        <tr>
                            <th style={{ width: "50%" }}>Large Halo</th>
                            <td>{values.large_halo || "-"}</td>
                        </tr>

                        <tr>
                            <th>Medium Halo</th>
                            <td>{values.medium_halo || "-"}</td>
                        </tr>

                        <tr>
                            <th>Small Halo</th>
                            <td>{values.small_halo || "-"}</td>
                        </tr>

                        <tr>
                            <th>No Halo</th>
                            <td>{values.no_halo || "-"}</td>
                        </tr>

                        <tr>
                            <th>Degraded</th>
                            <td>{values.degraded || "-"}</td>
                        </tr>

                        <tr>
                            <th>Total</th>
                            <td>{values.total || "-"}</td>
                        </tr>

                        {/* Fragmentation */}
                        <tr>
                            <th>Non Fragmented</th>
                            <td>{values.non_fragmented || "-"}</td>
                        </tr>

                        <tr>
                            <th>Fragmented</th>
                            <td>{values.fragmented || "-"}</td>
                        </tr>

                        <tr>
                            <th>DFI (%)</th>
                            <td>{values.DNA_index || "-"}</td>
                        </tr>

                        {/* Remark */}
                        <tr>
                            <th>Remark</th>
                            <td>{values.remark || "-"}</td>
                        </tr>

                    </tbody>
                </table>
            </>
            <>
                <h4 className="mt-4">DFI Data - COMET Assay</h4>

                <table className="print-table">
                    <tbody>

                        {/* Migration Data */}
                        <tr>
                            <th style={{ width: "50%" }}>No DNA Migration</th>
                            <td>{COMET.noMigration || "-"}</td>
                        </tr>

                        <tr>
                            <th>SSB Migration</th>
                            <td>{COMET.ssbMigration || "-"}</td>
                        </tr>

                        <tr>
                            <th>DSB Migration</th>
                            <td>{COMET.dsbMigration || "-"}</td>
                        </tr>

                        <tr>
                            <th>Both Damage Migration</th>
                            <td>{COMET.bothDamageMigration || "-"}</td>
                        </tr>

                        <tr>
                            <th>Total</th>
                            <td>{COMET.total || "-"}</td>
                        </tr>

                        {/* Damage Status */}
                        <tr>
                            <th>Undamaged</th>
                            <td>{COMET.undamaged || "-"}</td>
                        </tr>

                        <tr>
                            <th>Both Damaged</th>
                            <td>{COMET.bothDamaged || "-"}</td>
                        </tr>

                        {/* DFI Index */}
                        <tr>
                            <th>SSB DNA Fragmentation Index DFI (%)</th>
                            <td>{COMET.ssbDfi || "-"}</td>
                        </tr>

                        <tr>
                            <th>DSB DNA Fragmentation Index DFI (%)</th>
                            <td>{COMET.dsbDfi || "-"}</td>
                        </tr>

                        <tr>
                            <th>SSB & DSB DNA Fragmentation Index DFI (%)</th>
                            <td>{COMET.ssbDsbDfi || "-"}</td>
                        </tr>

                        {/* Remark */}
                        <tr>
                            <th>Remark</th>
                            <td>{COMET.remark || "-"}</td>
                        </tr>

                    </tbody>
                </table>
            </>
            <>
                <h4 className="mt-4">Oxidative Stress Data</h4>

                <table className="print-table">
                    <tbody>

                        <tr>
                            <th style={{ width: "50%" }}>
                                Percentage of chemiluminescence (to that of control)
                            </th>
                            <td>{Oxidative.chemiluminescence || "-"}</td>
                        </tr>

                        <tr>
                            <th>Remark</th>
                            <td>{Oxidative.remark || "-"}</td>
                        </tr>

                    </tbody>
                </table>
            </>
            <>
                <h4 className="mt-4">Y-Microdeletion Data</h4>

                <table className="print-table">
                    <tbody>

                        <tr>
                            <th>AZF a deletion</th>
                            <td>{ymicron.a_deletion === "1" ? "Yes" : "No"}</td>
                        </tr>

                        <tr>
                            <th>AZF b deletion</th>
                            <td>{ymicron.b_deletion === "1" ? "Yes" : "No"}</td>
                        </tr>

                        <tr>
                            <th>AZF c deletion</th>
                            <td>{ymicron.c_deletion === "1" ? "Yes" : "No"}</td>
                        </tr>

                        <tr>
                            <th>AZF abc deletion</th>
                            <td>{ymicron.abc_deletion === "1" ? "Yes" : "No"}</td>
                        </tr>

                        <tr>
                            <th>b1/b3 deletion</th>
                            <td>{ymicron.b1b3_deletion === "1" ? "Yes" : "No"}</td>
                        </tr>

                        <tr>
                            <th>gr/gr deletion</th>
                            <td>{ymicron.gr_deletion === "1" ? "Yes" : "No"}</td>
                        </tr>

                        <tr>
                            <th>b2/b3 deletion</th>
                            <td>{ymicron.b2b3_deletion === "1" ? "Yes" : "No"}</td>
                        </tr>

                        <tr>
                            <th>b2/b4 deletion</th>
                            <td>{ymicron.b2b4_deletion === "1" ? "Yes" : "No"}</td>
                        </tr>

                        <tr>
                            <th>Remark</th>
                            <td>{ymicron?.remark || "-"}</td>
                        </tr>

                    </tbody>
                </table>
            </>
            <>
                <h4 className="mt-4">Telomere Length</h4>

                <table className="print-table">
                    <tbody>

                        <tr>
                            <th style={{ width: "50%" }}>
                                Relative telomere length
                            </th>
                            <td>{Telomere.relative_length || "-"}</td>
                        </tr>

                        <tr>
                            <th>Remark</th>
                            <td>{Telomere.remark || "-"}</td>
                        </tr>

                    </tbody>
                </table>
            </>
            <>
                <h4 className="mt-4">Clinical Pregnancy Data</h4>
                <h5>After 14 Days Follow Up</h5>
                {["IUI", "IVF", "ICSI"].map((type, index) => {

                    const row = followup_14days.find(r => r.followup_type === type) || {};

                    return (
                        <div key={index}>

                            <h6 className="mt-3">
                                {type}
                            </h6>

                            <table className="print-table">
                                <tbody>

                                    <tr>
                                        <th style={{ width: "50%" }}>UPT</th>
                                        <td>
                                            {row.UPT === "1"
                                                ? "Positive"
                                                : row.UPT === "0"
                                                    ? "Negative"
                                                    : "-"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Beta HCG Value</th>
                                        <td>{row.hcg_value ?? "-"}</td>
                                    </tr>

                                    <tr>
                                        <th>G SGC</th>
                                        <td>{row.gsgc_value ?? "-"}</td>
                                    </tr>

                                    <tr>
                                        <th>Fetal Pole</th>
                                        <td>{row.fetal_pole ?? "-"}</td>
                                    </tr>

                                    <tr>
                                        <th>Cardiac Echo</th>
                                        <td>{row.cardiac_echo ?? "-"}</td>
                                    </tr>

                                    <tr>
                                        <th>Remark</th>
                                        <td>{row.remark ?? "-"}</td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                    );
                })}

            </>
            <>
                <h4 className="mt-4">
                    11<sup>th</sup> to 13<sup>th</sup> week
                </h4>

                {["IUI", "IVF", "ICSI"].map((type, index) => {

                    const row = followup_11_13weeks?.find(
                        r => r.followup_type === type
                    ) || {};

                    return (
                        <div key={index}>

                            <h6 className="mt-3">
                                {type}
                            </h6>

                            <table className="print-table">
                                <tbody>

                                    <tr>
                                        <th style={{ width: "50%" }}>Type</th>
                                        <td>{type}</td>
                                    </tr>

                                    <tr>
                                        <th>Remark</th>
                                        <td>{row?.remark ?? "-"}</td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                    );
                })}
            </>

            <>
                <h4 className="mt-4">
                    18<sup>th</sup> to 20<sup>th</sup> week
                </h4>

                {["IUI", "IVF", "ICSI"].map((type, index) => {

                    const row = followup_18_20weeks?.find(
                        r => r.followup_type === type
                    ) || {};

                    return (
                        <div key={index}>

                            <h6 className="mt-3">
                                {type}
                            </h6>

                            <table className="print-table">
                                <tbody>

                                    <tr>
                                        <th style={{ width: "50%" }}>Type</th>
                                        <td>{type}</td>
                                    </tr>

                                    <tr>
                                        <th>Remark</th>
                                        <td>{row?.remark ?? "-"}</td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                    );
                })}
            </>
            <>
                <h4 className="mt-4">
                    24<sup>th</sup> week
                </h4>

                {["IUI", "IVF", "ICSI"].map((type, index) => {

                    const row = followup_24weeks?.find(
                        r => r.followup_type === type
                    ) || {};

                    return (
                        <div key={index}>

                            <h6 className="mt-3">
                                {type}
                            </h6>

                            <table className="print-table">
                                <tbody>

                                    <tr>
                                        <th style={{ width: "50%" }}>Type</th>
                                        <td>{type}</td>
                                    </tr>

                                    <tr>
                                        <th>Remark</th>
                                        <td>{row?.remark ?? "-"}</td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                    );
                })}
            </>
            <>
                <h4 className="mt-4">Fertilization Rate</h4>

                {["IVF", "ICSI"].map((type, index) => {

                    const row = followup_fertilization_master?.find(
                        r => r.followup_type === type
                    ) || {};

                    return (

                        <div key={index}>

                            <h6 className="mt-3">
                                {type}
                            </h6>

                            <table className="print-table">
                                <tbody>

                                    <tr>
                                        <th style={{ width: "50%" }}>Oocytes Obtained</th>
                                        <td>{row?.oocytes_obtained ?? "-"}</td>
                                    </tr>

                                    <tr>
                                        <th>M I</th>
                                        <td>{row?.mi_value ?? "-"}</td>
                                    </tr>

                                    <tr>
                                        <th>M II</th>
                                        <td>{row?.Mii_value ?? "-"}</td>
                                    </tr>

                                    <tr>
                                        <th>Oocytes Fertilized</th>
                                        <td>{row?.oocytes_fertilized ?? "-"}</td>
                                    </tr>

                                    <tr>
                                        <th>Embryos Transferred</th>
                                        <td>{row?.embryos_transferred ?? "-"}</td>
                                    </tr>

                                    <tr>
                                        <th>Grade</th>
                                        <td>{row?.grade ?? "-"}</td>
                                    </tr>

                                    <tr>
                                        <th>Transfer</th>
                                        <td>{row?.transfer ?? "-"}</td>
                                    </tr>

                                    <tr>
                                        <th>Remark</th>
                                        <td>{row?.remark ?? "-"}</td>
                                    </tr>

                                </tbody>
                            </table>




                            <table className="print-table mt-3">

                                <thead>
                                    <tr>
                                        <th>Sr No</th>
                                        <th>Day 0 (ICSI)</th>
                                        <th>Day 1 (Fertilization)</th>
                                        <th>Day 3 (Embryo)</th>
                                    </tr>
                                </thead>

                                <tbody>


                                    {row?.dates?.length > 0 ? (

                                        row.dates.map((d, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{d?.day0 ?? "-"}</td>
                                                <td>{d?.day1 ?? "-"}</td>
                                                <td>{d?.day2 ?? "-"}</td>
                                            </tr>
                                        ))

                                    ) : (

                                        <tr>
                                            <td colSpan="4" style={{ textAlign: "center" }}>
                                                No data available
                                            </td>
                                        </tr>

                                    )}

                                </tbody>

                            </table>


                        </div>

                    );

                })}

            </>
            <PrintFooter />
        </div >
    );



}

export default All_Report_download;